<template>
    <div class="fullHeight">
        <div class="row row-notMx justify-content-center">
            <div class="col-sm-6 col-notMx px-2">
                <div class="pageTitles">
                    <div class="icon-icon-info mypage-title-icon"></div>
                    {{ page_title }}
                </div>
                <div class="cardwindow">
                    <div class="col-sm-12">
                        <div>
                            <p>会員の退会が完了しました。<br>ご利用ありがとうございました。</p>
                        </div>
                    </div>
                </div>
                <!-- <div class="row mypage-info-record">
                    <div class="col-lg-3 ml-md-auto mr-md-auto text-center py-2">
                        <button
                            type="button"
                            class="btn btn-outline-info footer-btn-size"
                            @click="toLoginPage()"
                        >
                            ログインページに戻る
                        </button>
                    </div>
                </div> -->
            </div>
        </div>
    </div>
</template>

<script>
import MypageSideMenu from './MypageSideMenu';

export default {
    components: {
        MypageSideMenu,
    },
    data () {
        return {
            page_title: '会員退会完了'
        };
    },
    created () {
        this.initialize();
    },
    methods: {
        /** ----------------------------------------------
         * 初期表示時処理
         * ---------------------------------------------- */
        initialize () {
            localStorage.removeItem('web-token');
        },
        // toLoginPage: function() {
        //     this.$router.push("/");
        // }
    }
}

</script>
